import { render, staticRenderFns } from "./DaySelector.vue?vue&type=template&id=5fb47e77&lang=pug&"
import script from "./DaySelector.vue?vue&type=script&lang=js&"
export * from "./DaySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports